import { render, staticRenderFns } from "./VueJSONEditor.vue?vue&type=template&id=202311e0&scoped=true&"
import script from "./VueJSONEditor.vue?vue&type=script&lang=ts&"
export * from "./VueJSONEditor.vue?vue&type=script&lang=ts&"
import style0 from "./VueJSONEditor.vue?vue&type=style&index=0&id=202311e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202311e0",
  null
  
)

export default component.exports